<template>
  <section
    class="hero is-link is-fullheight-with-navbar"
    style="
      background-size: cover;
      background-position: bottom;
    "
    :style="{
      'background-image': 'url(' + dunes + ')'
    }"
  >
    <container-box>
      <h2 class="subtitle has-text-dark">Vous vous êtes perdus ?</h2>
      <p>
        Pour vous rediriger, utilisez les liens de <strong>navigations</strong>.
      </p>
    </container-box>
  </section>
</template>

<script>
import ContainerBox from "@/components/ContainerBox";
import yellowDunes from "@/assets/yellowDunes.svg";

export default {
  components: { ContainerBox },
  data() {
    return {
      dunes: yellowDunes
    };
  }
};
</script>
